import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Navigate,
} from "react-router-dom";
import { Routes, useLocation } from "react-router-dom";
import { useEffect } from "react";
import "./App.css";
import Home from "./MyComponents/Home";
import MathCourseDetails from "./MyComponents/MathPortal/MathCourseDetails";
import BenefitDetail from "./MyComponents/MathPortal/BenefitDetail";
import HighlightsDetail from "./MyComponents/MathPortal/HighlightsDetail";

import Blogs from "./MyComponents/Blogs";
import Blog1 from "./MyComponents/Blog1";
import Blog2 from "./MyComponents/Blog2";
import Blog3 from "./MyComponents/Blog3";
import Gallery from "./MyComponents/Gallery";

import SignIn from "./MyComponents/SignIn";
import SignUp from "./MyComponents/SignUp";

import QuranCourseDetails from "./MyComponents/QuranPortal/QuranCourseDetails";
import GraphicCourseDetails from "./MyComponents/GraphicDesignPortal/GraphicCourseDetails";

import Vision from "./MyComponents/FooterPages/OurVision";
import PolymathKidSchool from "./MyComponents/FooterPages/PolymathKidSchool";
import AboutUs from "./MyComponents/FooterPages/AboutUs";
import TermsOfUse from "./MyComponents/FooterPages/TermsOfUse";
import Cancellation from "./MyComponents/FooterPages/Cancellation";
import Policy from "./MyComponents/FooterPages/Policy";
import ContactUs from "./MyComponents/FooterPages/ContactUs";
import EngineeringCourseDetails from "./MyComponents/EngineeringPortal/EngineeringCourseDetails";
import CivilEngineering from "./MyComponents/EngineeringPortal/CivilEngineering";

// import { UserProvider } from './MyComponents/UserContext';
import { useContext } from "react";
import { UserContext } from "./MyComponents/UserContext";
import GuestNav from "./MyComponents/Navbars/GuestNav";
import StudentNav from "./MyComponents/Navbars/StudentNav";
import TeacherNav from "./MyComponents/Navbars/TeacherNav";
import AdminNav from "./MyComponents/Navbars/AdminNav";

import UserContextProvider from "./MyComponents/UserContext";
import CourseContext from "./MyComponents/CourseContext";
import Layout from "./MyComponents/Layout/Layout";

import ArchitectureCourseDetails from "./MyComponents/ArchitecturePortal/ArchitectureCourseDetails";
import SpaceSciencesCourseDetails from "./MyComponents/SpaceSciencePortal/SpaceSciencesCourseDetails";
import Astronomy from "./MyComponents/SpaceSciencePortal/Astronomy";

import RegisterInCourse from "./MyComponents/Actions/RegisterInCourse";
import AttendClass from "./MyComponents/Actions/AttendClass";
import MyProgress from "./MyComponents/Actions/MyProgress";
import TeacherAttendClass from "./MyComponents/Actions/TeacherAttendClass";
import { useState } from "react";
import ManageClasses from "./MyComponents/AdminActions/ManageClasses";
import User from "./MyComponents/ManageUser/User";
import CourseRegistration from "./MyComponents/AdminActions/CourseRegistration";

import WrittenActivity from "./MyComponents/Activities/WrittenActivity/WrittenActivity";
import MCQActivity from "./MyComponents/Activities/MCQActivity/MCQActivity";
import SpeedQuizActivity from "./MyComponents/Activities/SpeedQuizActivity/SpeedQuizActivity";
import LeaderBoard from "./MyComponents/Activities/SpeedQuizActivity/LeaderBoard";
import MentalActivity from "./MyComponents/Activities/MentalActivity/MentalActivity";
import OralActivity from "./MyComponents/Activities/OralActivity/OralActivity";
import VideoActivity from "./MyComponents/Activities/VideoActivity/VideoActivity";

import AdminRegisterInCourse from "./MyComponents/AdminActions/AdminRegisterInCourse";
import ActivitiesAndProjects from "./MyComponents/Actions/ActivitiesAndProjects";
import ActivitiesndProjects from "./MyComponents/Actions/ActivityProject";
import IslamicKnowledgeCourse from "./MyComponents/QuranPortal/IslamicKnowledgeCourse";
// import ProtectedRoute from "./MyComponents/ProtectedRoute"; // Using local definition instead
import { useNavigate } from "react-router-dom/dist/umd/react-router-dom.development";
import Password from "./MyComponents/Actions/password";
import AdminEdit from "./MyComponents/Actions/AdminEdit";
import EditProfile from "./MyComponents/Actions/EditProfile";
import Teacher from "./MyComponents/Actions/Teacher";
import Managecontent from "./MyComponents/ManageContent/managecontent";
import Faqs from "./MyComponents/FooterPages/Faqs";

import CPP from "./MyComponents/CodingPortal/CPP";
import PromptEngineering from "./MyComponents/CodingPortal/PromptEngineering";
import Android from "./MyComponents/CodingPortal/Android";
import Unity from "./MyComponents/CodingPortal/Unity";
import ML from "./MyComponents/CodingPortal/ML";
import CommunicationCourseDetails from "./MyComponents/CommunicationPortal/CommunicationCourseDetails";
import CPS from "./MyComponents/CommunicationPortal/CPS";
import ScrollToTop from "./MyComponents/components/ScrollToTop";
import ExamActivity from "./MyComponents/Activities/ExamActivity/ExamActivity";
import ChangeTeachersAndClass from "./MyComponents/AdminActions/ChangeTeachersAndClass";
import TeacherProfile from "./MyComponents/AdminActions/TeacherProfile";
import TeacherRating from "./MyComponents/AdminActions/TeacherRating";
import TeacherSalary from "./MyComponents/AdminActions/TeacherSalary";
import MyCalender from "./MyComponents/CalenderView/MyCalender";
import MyRewards from "./MyComponents/MyRewards/MyRewards";
import StudentReward from "./MyComponents/MyRewards/StudentReward";
import LocationInfo from "./MyComponents/LocationInfo/LocationInfo";
import ActivityStartPage from "./MyComponents/Activities/ActivityStart/ActivityStartPage";
import StudentDashboard from "./MyComponents/Actions/StudentDashboard";
import TeacherCourses from "./MyComponents/Actions/TeacherCourses";
import StudentCourses from "./MyComponents/Actions/StudentCourses";
import GradeProjectPage from "./MyComponents/Actions/GradeProjectPage";
import ActivityResult from "./MyComponents/Activities/ActivityResult/ActivityResult";
import UnAuthorized from "./MyComponents/UnAuth/UnAuthorized";
import ClipLoader from "react-spinners/ClipLoader";

import GenerateMeetingLink from "./MyComponents/AdminActions/GenerateMeetingLink";
import Polymatch from "./MyComponents/PromotionalPages/Polymatch";
import PolymatchReg from "./MyComponents/PromotionalPages/PolymatchReg";
import PolymatchResults from "./MyComponents/PromotionalPages/PolymatchResults";
import PolymatchResults_Linguistic from "./MyComponents/PromotionalPages/PolymatchResult_Linguistic";
import PolymatchResults_Islamic from "./MyComponents/PromotionalPages/PolymatchResults_Islamic";
import PolymatchResults_Science from "./MyComponents/PromotionalPages/PolymatchResults_Science";
import PolymatchResults_Coding from "./MyComponents/PromotionalPages/PolymatchResults_Coding";
import PolymatchResults_GraphicDesigning from "./MyComponents/PromotionalPages/PolymatchResults_GraphicDesigning";
import PolymatchDetail from "./MyComponents/PromotionalPages/PolymatchDetail";
import Polymatchtermandservices from "./MyComponents/PromotionalPages/Polytermandservices";
import MassCommunication from "./MyComponents/PromotionalPages/MassCommunication";
// import SummerCamp from "./MyComponents/PromotionalPages/SummerCamp";
import PayPalPayment from "./MyComponents/PaymentIntegration/PayPalPayment";
import InvoiceTable from "./MyComponents/StudentInvoices/InvoiceTable";
import MakePaymentPage from "./MyComponents/StudentInvoices/MakePaymentPage";
import CreateCertificate from "./MyComponents/CertificateGeneration/CreateCertificate";
import PDF from "./MyComponents/CertificateGeneration/PDF";
import { PDFDownloadLink } from "@react-pdf/renderer";
import AB from "./MyComponents/CertificateGeneration/AB";
import FeeConfig from "./MyComponents/MyFees/FeeConfig";
import PolymatchInvoice from "./MyComponents/PromotionalPages/PolymatchInvoice";
import ManageRewards from "./MyComponents/MyRewards/ManageRewards";
import RedeemRequest from "./MyComponents/MyRewards/RedeemRequest";
import RedeemHistory from "./MyComponents/MyRewards/RedeemHistory";
import StudentFee from "./MyComponents/MyFees/StudentFee";
import StudentProgress from "./MyComponents/Actions/StudentProgress";
import PasswordForget from "./MyComponents/Actions/passwordForget";
import CreateCertificate2 from "./MyComponents/CertificateGeneration/CreateCertificate2";
import ChatbotAdminPanel from "./MyComponents/ChatBot/ChatbotAdminPanel";
import BookADemo from './MyComponents/ChatBot/DemoBookingPage';
import ChatHistory from './MyComponents/ChatBot/ChatHistory';
import Demoadmin from './MyComponents/ChatBot/Demo-admin';
import DemoHistory from './MyComponents/ChatBot/DemoHistory';
import Invoice from "./MyComponents/PromotionalPages/invoice";
import DataDisplay from "./MyComponents/DataDisplay/DataDisplay";



//  Hammad section
// import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import LifeSkillCourses from "./pages/LifeSkillCourses";
import SummerCamp from "./pages/SummerCamp";
import WinterCamp from "./pages/WinterCamp";
import PopularCourses from "./MyComponents/PopularCourses";
import MathPage from "./pages/StemCourses/MathPortal";
import CodingPage from "./pages/StemCourses/CodingPortal";
import GraphicDesignPortal from "./pages/StemCourses/GraphicDesignPortal";
import QuranPage from "./pages/StemCourses/QuranPortal";
import BusinessPortal from "./pages/StemCourses/BusinessPortal";
import EngineeringPage from "./pages/StemCourses/EngineeringPortal";
import ArchitecturePage from "./pages/StemCourses/ArchitecturePortal";
import CommunicationPage from "./pages/StemCourses/CommunicationSkillsPortal";
import SpaceSciencesPage from "./pages/StemCourses/SpaceSciencesPortal";

import AdobeXD from "./pages/StemCourses/SubcoursesGraphicDesign/AdobeXD";
import CorelDraw from "./pages/StemCourses/SubcoursesGraphicDesign/CorelDraw";
import PhotoShop from "./pages/StemCourses/SubcoursesGraphicDesign/PhotoShop";
import Illustrator from "./pages/StemCourses/SubcoursesGraphicDesign/Illustrator";
import Canva from "./pages/StemCourses/SubcoursesGraphicDesign/Canva";
import ThreeDModel from "./pages/StemCourses/SubcoursesGraphicDesign/ThreeDModel";
import Figma from "./pages/StemCourses/SubcoursesGraphicDesign/Figma";
import Kidprenur from "./pages/StemCourses/SubCoursesBusinessPortal/Kidprenur";
import ScratchProgramming from "./pages/StemCourses/SubCoursesCodingPortal/ScratchProgramming";
import AppDevelopment from "./pages/StemCourses/SubCoursesCodingPortal/AppDevelopment";
import WebDevelopment from "./pages/StemCourses/SubCoursesCodingPortal/WebDevelopment";
import GameDevelopment from "./pages/StemCourses/SubCoursesCodingPortal/GameDevelopment";
import PHP from "./pages/StemCourses/SubCoursesCodingPortal/PHP";
import AIDataScience from "./pages/StemCourses/SubCoursesCodingPortal/AIDataScience";
import Python from "./pages/StemCourses/SubCoursesCodingPortal/Python";
import BrainTrainAbacusPortal from "./pages/StemCourses/SubCourses/BrainTrainAbacusPortal";
import BrainTrainAbacusJuniorPortal from "./pages/StemCourses/SubCourses/BrainTrainAbacusJuniorPortal";
import CommunicationSkillsCoursePortal from "./pages/StemCourses/SubCourses/CommunicationSkillsCoursePortal";
import CivilEngineeringPortal from "./pages/StemCourses/SubCourses/CivilEngineeringPortal";
import AstronomyPortal from "./pages/StemCourses/SubCourses/AstronomyPortal";
import IslamicKnowledgePortal from "./pages/StemCourses/SubCourses/IslamicKnowledgePortal";
import ArchitectureInteriorDesignPortal from "./pages/StemCourses/SubCourses/Architecture&InteriorDesignPortal";
import CppProgrammingPortal from "./pages/StemCourses/SubCourses/CppProgrammingPortal";
import UnityGameDevPortal from "./pages/StemCourses/SubCourses/UnityGameDevPortal";
import AndroidAppDevPortal from "./pages/StemCourses/SubCourses/AndroidAppDevPortal";
import MachineLearningPortal from "./pages/StemCourses/SubCourses/MachineLearningPortal";
import AIpromptEngineering from "./pages/StemCourses/SubCourses/AIpromptEngineering";
import MentalMath from "./MyComponents/PromotionalPages/mentalmath";
import English from "./MyComponents/PromotionalPages/english";
import IQ_competition from "./MyComponents/PromotionalPages/IQ_competition";
import Islamic from "./MyComponents/PromotionalPages/Islamic";
import Coding from "./MyComponents/PromotionalPages/Coding";
import GraphicDesigning from "./MyComponents/PromotionalPages/GraphicDesigning";
import Science from "./MyComponents/PromotionalPages/Science";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import "./MyComponents/MyFees/StudentFee.css";

function NavbarSelector() {
  const { isStudent, isTeacher, isAdmin, isGuest, setUserInfo, setUserRole } =
    useContext(UserContext);
  const navigate = useNavigate();
  const location = useLocation();
  console.log(location.pathname);
  const onLogout = async () => {
    await fetch(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/logout`, {
      credentials: "include",
      method: "POST",
    });
    setUserInfo(null);
    setUserRole("guest");
    navigate("/");
  };

  // Don't show any navbar on sign-in and signup pages
  if (location.pathname === "/sign-in" || location.pathname === "/signup") {
    return null;
  }

  if (isStudent) return <StudentNav onLogout={onLogout} />;
  else if (isTeacher) return <TeacherNav onLogout={onLogout} />;
  else if (isAdmin && location.pathname === "/") return <AdminNav onLogout={onLogout} />;
  else if (isAdmin && location.pathname !== "/") return null;
  return <GuestNav />;
}

function App() {
  const [Course, setCourse] = useState("");
  const handleCourseSelect = (course) => {
    // Do something with the selected course
    setCourse(course);
  };

  const fetchData = async () => {
    try {
      // Method 1: Try session API first
      const response = await fetch(
        `${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}`,
        {
          credentials: "include",
        }
      );
      const userInfo = await response.json();
      console.log("ProtectedRoute fetchData response:", userInfo);

      // Check if user is authenticated and has valid session
      if (response.ok && userInfo?.valid && userInfo?.usertype) {
        console.log(
          "✅ ProtectedRoute: Found usertype in session:",
          userInfo.usertype
        );
        return userInfo.usertype;
      } else {
        console.log(
          "⚠️ ProtectedRoute: Session invalid, checking localStorage..."
        );

        // Method 2: Fallback to localStorage
        const storedUserType = localStorage.getItem("usertype");
        const storedUserId = localStorage.getItem("User_id");

        console.log("🔍 ProtectedRoute localStorage check:", {
          usertype: storedUserType,
          User_id: storedUserId,
        });

        if (storedUserType && storedUserId) {
          console.log(
            "✅ ProtectedRoute: Found usertype in localStorage:",
            storedUserType
          );
          return storedUserType;
        } else {
          console.log("❌ ProtectedRoute: No usertype found anywhere");
          return "guest";
        }
      }
    } catch (error) {
      console.log(
        "❌ ProtectedRoute session error, checking localStorage...",
        error.message
      );

      // Method 2: Fallback to localStorage on error
      const storedUserType = localStorage.getItem("usertype");
      const storedUserId = localStorage.getItem("User_id");

      if (storedUserType && storedUserId) {
        console.log(
          "✅ ProtectedRoute: Found usertype in localStorage (fallback):",
          storedUserType
        );
        return storedUserType;
      } else {
        console.log(
          "❌ ProtectedRoute: No usertype found in localStorage either"
        );
        return "guest";
      }
    }
  };

  const ProtectedRoute = ({ path, allowedRoles, component }) => {
    const [userType, setUserType] = useState(null);

    useEffect(() => {
      fetchData().then((type) => {
        setUserType(type);
      });
    }, []);


    // if (userType === null)
    // {
    //   return <div style={{textAlign:"center"}}>Loading...</div>;
    // }
    // // console.log('userType1:', userType);
    if (userType === null) {
      return (
        <div className="loading-container">
          <ClipLoader size={50} color={"#123abc"} loading={true} />
          <div className="loading-text">Loading...</div>
        </div>
      );
    }
    const isAllowed = allowedRoles.includes(userType);

    console.log(isAllowed);
    // console.log('userType:', userType);
    console.log(allowedRoles);
    // console.log("Component:",component)
    return isAllowed ? (
      <>
        {/* console.log({component}); */}
        <div>{component}</div>

      </>
    ) : (
      <Navigate to="/" replace />
      // <UnAuthorized />

      // <Home   selectedCourse={handleCourseSelect}/>
    );
  };
  return (
    <>
      <ToastContainer
        position="top-center"
        autoClose={3000}
        pauseOnFocusLoss={false}
        draggable
        pauseOnHover={false}
      //  transition= 'Bounce'
      />
      <Router>
        <UserContextProvider>
          <NavbarSelector />
          <ScrollToTop />
          <Layout>
            <Routes>
              <Route
                path="/"
                element={<Home selectedCourse={handleCourseSelect} />}
              />
              <Route path="/gallery" element={<Gallery />} />
              <Route
                path="/StudentProgress"
                element={
                  <ProtectedRoute
                    allowedRoles={["Admin", "Teacher"]}
                    component={<StudentProgress />}
                  />
                }
              />
              {/* --------------------------- */}
              <Route
                path="/GenerateMeetingLink"
                element={
                  <ProtectedRoute
                    allowedRoles={["Admin", "Teacher"]}
                    component={<GenerateMeetingLink />}
                  />
                }
              />
              {/* <Route
              path="/AttendClass"
              element={
                <ProtectedRoute
                  allowedRoles={["Student"]}
                  component={<AttendClass />}
                />
              }
            /> */}
              {/* <Route path="/AttendClass/:courseId" element={<AttendClass />} /> */}
              <Route
                path="/AttendClass"
                element={<ProtectedRoute allowedRoles={['Student']} component={<AttendClass />} />}
              />
              <Route
                path="/MyProgress/:courseId"
                element={
                  <ProtectedRoute
                    allowedRoles={["Student"]}
                    component={<MyProgress />}
                  />
                }
              />
              {/* <Route path="/MyProgress/:courseId" element={<MyProgress />} /> */}
              <Route
                path="/ActivitiesAndProjects/:courseId"
                element={
                  <ProtectedRoute
                    allowedRoles={["Student"]}
                    component={<ActivitiesAndProjects />}
                  />
                }
              />
              {/* <Route
              path="/ActivitiesAndProjects/:courseId"
              element={<ActivitiesAndProjects />}
            /> */}
              <Route
                path="/ActivityProject/:courseId"
                element={
                  <ProtectedRoute
                    allowedRoles={["Student"]}
                    component={<ActivitiesndProjects />}
                  />
                }
              />
              <Route
                path="/ActivityStartPage"
                element={
                  <ProtectedRoute
                    allowedRoles={["Student"]}
                    component={<ActivityStartPage />}
                  />
                }
              />
              <Route
                path="/RegisterInCourse"
                element={
                  <ProtectedRoute
                    allowedRoles={["Student"]}
                    component={<RegisterInCourse />}
                  />
                }
              />
              <Route
                path="/LeaderBoard"
                element={
                  <ProtectedRoute
                    allowedRoles={["Student"]}
                    component={<LeaderBoard />}
                  />
                }
              />
              <Route
                path="/StudentDashboard/:courseId"
                element={<ProtectedRoute allowedRoles={['Teacher']} component={<StudentDashboard />} />}
              />
              <Route
                path="/GradeProjectPage/:courseId"
                element={<GradeProjectPage />}
              />
              <Route
                path="/TakeClass/:courseId"
                element={<TeacherAttendClass />}
              />
              <Route
                path="/ActivityResult"
                element={
                  <ProtectedRoute
                    allowedRoles={["Admin", "Teacher"]}
                    component={<ActivityResult />}
                  />
                }
              />
              <Route
                path="/admin_levels_coding"
                element={
                  <ProtectedRoute
                    allowedRoles={["Admin"]}
                    component={<Managecontent />}
                  />
                }
              />
              <Route
                path="/admin_manage_classes/:courseId/:coursename"
                element={
                  <ProtectedRoute
                    allowedRoles={["Admin"]}
                    component={<ManageClasses />}
                  />
                }
              />
              <Route
                path="/ManageUser"
                element={
                  <ProtectedRoute allowedRoles={["Admin"]} component={<User />} />
                }
              />
              <Route
                path="/CourseRegistration"
                element={
                  <ProtectedRoute
                    allowedRoles={["Admin"]}
                    component={<CourseRegistration />}
                  />
                }
              />
              <Route path="/BookADemo" element={<BookADemo />} />
              <Route path="/locationinfo" element={<LocationInfo />} />
              <Route path="/chat-history" element={<ChatHistory />} allowedRoles={['Admin']} />
              <Route path="/Demo-admin" element={<Demoadmin />} allowedRoles={['Admin']} />
              <Route path="/DemoHistory" element={<DemoHistory />} allowedRoles={['Admin']} />
              <Route
                path="/data-display"
                element={
                  <ProtectedRoute
                    allowedRoles={['Admin']}
                    component={<DataDisplay />}
                  />
                }
              />

              <Route
                path="/ChangePassword"
                element={
                  <ProtectedRoute
                    allowedRoles={["Admin", "Student", "Teacher"]}
                    component={<Password />}
                  />
                }
              />
              <Route path="/ChangeForgetPassword" element={<PasswordForget />} />
              <Route
                path="/AdminEdit"
                element={
                  <ProtectedRoute
                    allowedRoles={["Admin"]}
                    component={<AdminEdit />}
                  />
                }
              />
              <Route
                path="/gen_certificate/:courseId/:coursename"
                element={
                  <ProtectedRoute
                    allowedRoles={["Admin"]}
                    component={<CreateCertificate />}
                  />
                }
              />
              <Route
                path="/gen_certificate2"
                element={
                  <ProtectedRoute
                    allowedRoles={["Admin"]}
                    component={<CreateCertificate2 />}
                  />
                }
              />
              <Route
                path="/AB"
                element={
                  <ProtectedRoute allowedRoles={["Admin"]} component={<AB />} />
                }
              />
              <Route
                path="/FeeConfig"
                element={
                  <ProtectedRoute
                    allowedRoles={["Admin"]}
                    component={<FeeConfig />}
                  />
                }
              />
              <Route
                path="/ManageRewards"
                element={
                  <ProtectedRoute
                    allowedRoles={["Admin"]}
                    component={<ManageRewards />}
                  />
                }
              />
              <Route
                path="/PolymatchInvoice"
                element={
                  <ProtectedRoute
                    allowedRoles={["Admin"]}
                    component={<PolymatchInvoice />}
                  />
                }
              />
              <Route
                path="/RedeemHistory"
                element={
                  <ProtectedRoute
                    allowedRoles={["Admin"]}
                    component={<RedeemHistory />}
                  />
                }
              />
              <Route
                path="/RedeemRequest"
                element={
                  <ProtectedRoute
                    allowedRoles={["Admin"]}
                    component={<RedeemRequest />}
                  />
                }
              />
              <Route
                path="/StudentFee"
                element={
                  <ProtectedRoute
                    allowedRoles={["Admin"]}
                    component={<StudentFee />}
                  />
                }
              />
              <Route
                path="/MassCommunication"
                element={
                  <ProtectedRoute
                    allowedRoles={["Admin"]}
                    component={<MassCommunication />}
                  />
                }
              />
              {/* <Route
      path="/pdf"
      element={<ProtectedRoute   allowedRoles={['Admin']} component={<PDF/>}/>}
    /> */}
              <Route
                path="/EditProfile"
                element={
                  <ProtectedRoute
                    allowedRoles={["Student", "Teacher"]}
                    component={<EditProfile />}
                  />
                }
              />
              {/* <Route
              path="/TeacherEditProfile"
              element={
                <ProtectedRoute
                  allowedRoles={["Teacher"]}
                  component={<Teacher />}
                />
              }
            /> */}
              <Route
                path="/TeacherCourses"
                element={
                  <ProtectedRoute
                    allowedRoles={["Teacher"]}
                    component={<TeacherCourses />}
                  />
                }
              />
              <Route
                path="/StudentCourses"
                element={
                  <ProtectedRoute
                    allowedRoles={["Student"]}
                    component={<StudentCourses />}
                  />
                }
              />
              <Route
                path="/AdminRegisterInCourse"
                element={
                  <ProtectedRoute
                    allowedRoles={["Admin"]}
                    component={<AdminRegisterInCourse />}
                  />
                }
              />
              <Route
                path="/CourseRegistration"
                element={
                  <ProtectedRoute
                    allowedRoles={["Admin"]}
                    component={<CourseRegistration />}
                  />
                }
              />
              <Route
                path="/TeacherProfile"
                element={
                  <ProtectedRoute
                    allowedRoles={["Admin"]}
                    component={<TeacherProfile />}
                  />
                }
              />
              <Route
                path="/TeacherRating"
                element={
                  <ProtectedRoute
                    allowedRoles={["Admin"]}
                    component={<TeacherRating />}
                  />
                }
              />
              <Route
                path="/TeacherSalary"
                element={
                  <ProtectedRoute
                    allowedRoles={["Admin"]}
                    component={<TeacherSalary />}
                  />
                }
              />
              {/* Promotional content*/}
              <Route path="/polymatch" element={<Polymatch />} />
              <Route path="/PolymatchReg" element={<PolymatchReg />} />
              <Route path="/PolymatchResults" element={<PolymatchResults />} />
              <Route path="/polymatchtermandservices" element={<Polymatchtermandservices />} />
              <Route
                path="/PolymatchResults_Linguistic"
                element={<PolymatchResults_Linguistic />}
              />
              {/* <Route
              path="/PolymatchResults_Islamic"
              element={<PolymatchResults_Islamic />}
            /> */}
              <Route
                path="/PolymatchResults_Islamic"
                element={<PolymatchResults_Islamic />}
              />
              <Route
                path="/PolymatchResults_Science"
                element={<PolymatchResults_Science />}
              />
              <Route
                path="/PolymatchResults_Coding"
                element={<PolymatchResults_Coding />}
              />
              <Route
                path="/PolymatchResults_GraphicDesigning"
                element={<PolymatchResults_GraphicDesigning />}
              />
              <Route path="/PolymatchDetail" element={<PolymatchDetail />} />
              {/* <Route path="/summer_camp" element={<SummerCamp />} /> */}
              {/* Math  Portal */}
              <Route
                path="/abacus_home2"
                element={
                  <MathCourseDetails selectedCourse={handleCourseSelect} />
                }
              />
              <Route
                path="/abacus_benefits"
                element={<BenefitDetail selectedCourse={handleCourseSelect} />}
              />
              <Route
                path="/abacus_learning_portal"
                element={<HighlightsDetail selectedCourse={handleCourseSelect} />}
              />
              {/* Coding Portal */}
              <Route
                path="/coding_cplus2"
                element={<CPP selectedCourse={handleCourseSelect} />}
              />
              <Route
                path="/coding_game_dev_unity2"
                element={<Unity selectedCourse={handleCourseSelect} />}
              />
              <Route
                path="/coding_machine_learning2"
                element={<ML selectedCourse={handleCourseSelect} />}
              />
              <Route
                path="/coding_app_dev_androidstu2"
                element={<Android selectedCourse={handleCourseSelect} />}
              />
              <Route
                path="/coding_ai_promptengineer2"
                element={
                  <PromptEngineering selectedCourse={handleCourseSelect} />
                }
              />
              {/* Quran Portal */}
              <Route
                path="/quran_portal2"
                element={
                  <QuranCourseDetails selectedCourse={handleCourseSelect} />
                }
              />
              <Route
                path="/quran_islamic_knowledge2"
                element={
                  <IslamicKnowledgeCourse selectedCourse={handleCourseSelect} />
                }
              />
              {/* Graphic Designing Portal */}
              <Route
                path="/graphic_designing_portal2"
                element={
                  <GraphicCourseDetails selectedCourse={handleCourseSelect} />
                }
              />
              {/* <Route
              path="/graphic_designing_adobexd"
              element={<AdobeXD selectedCourse={handleCourseSelect} />}
            /> */}
              {/* <Route
              path="/graphic_designing_corel"
              element={<CorelDraw selectedCourse={handleCourseSelect} />}
            /> */}
              {/* <Route
              path="/graphic_designing_photosh"
              element={<PhotoShop selectedCourse={handleCourseSelect} />}
            />
            <Route
              path="/graphic_designing_canva"
              element={<Canva selectedCourse={handleCourseSelect} />}
            />
            <Route
              path="/graphic_designing_illustr"
              element={<Illustrator selectedCourse={handleCourseSelect} />}
            /> */}
              {/* Engineering Portal */}
              <Route
                path="/engineering_portal2"
                element={
                  <EngineeringCourseDetails selectedCourse={handleCourseSelect} />
                }
              />
              <Route
                path="/engineering_civil2"
                element={<CivilEngineering selectedCourse={handleCourseSelect} />}
              />
              {/* Architecture Portal */}
              <Route
                path="/arch_interior_design2"
                element={
                  <ArchitectureCourseDetails
                    selectedCourse={handleCourseSelect}
                  />
                }
              />
              {/* Space Science Portal */}
              <Route
                path="/space_sc_portal2"
                element={
                  <SpaceSciencesCourseDetails
                    selectedCourse={handleCourseSelect}
                  />
                }
              />
              <Route
                path="/space_sc_atronomy2"
                element={<Astronomy selectedCourse={handleCourseSelect} />}
              />
              {/* communication Portal */}
              <Route
                path="/comm_skills_portal2"
                element={
                  <CommunicationCourseDetails
                    selectedCourse={handleCourseSelect}
                  />
                }
              />
              <Route
                path="/comm_comm_skills2"
                element={<CPS selectedCourse={handleCourseSelect} />}
              />
              {/*Footer Pages  */}
              <Route
                path="/polymatch"
                element={<Polymatch selectedCourse={handleCourseSelect} />}
              />
              <Route
                path="/our_vision"
                element={<Vision selectedCourse={handleCourseSelect} />}
              />
              <Route
                path="/polymathkids_at_schools"
                element={<PolymathKidSchool />}
              />
              <Route path="/about-us" element={<AboutUs />} />
              <Route
                path="/terms_of_use"
                element={<TermsOfUse selectedCourse={handleCourseSelect} />}
              />
              <Route
                path="/privacy_policy"
                element={<Policy selectedCourse={handleCourseSelect} />}
              />
              <Route
                path="/cancelation_refund_policy"
                element={<Cancellation selectedCourse={handleCourseSelect} />}
              />
              <Route path="/faqs" element={<Faqs />} />
              <Route path="/contact_us" element={<ContactUs />} />
              {/* Mohsin Routes */}
              <Route path="/WrittenActivity" element={<WrittenActivity />} />
              <Route
                path="/MCQActivity"
                element={<MCQActivity activityId={4} />}
              />
              <Route
                path="/SpeedQuizActivity"
                element={<SpeedQuizActivity activityId={4} />}
              />
              <Route
                path="/MentalActivity"
                element={<MentalActivity activityId={4} />}
              />
              <Route
                path="/OralActivity"
                element={<OralActivity activityId={2} />}
              />
              <Route
                path="/VideoActivity"
                element={<VideoActivity activityId={1} />}
              />
              <Route
                path="/ExamActivity"
                element={<ExamActivity activityId={1} />}
              />
              <Route
                path="/ChangeTeacherAndClass"
                element={<ChangeTeachersAndClass />}
              />
              <Route path="/PaypalPayment" element={<PayPalPayment />} />
              <Route path="/studentInvoices" element={<InvoiceTable />} />
              <Route path="/MakePaymentPage" element={<MakePaymentPage />} />
              <Route path="/invoice/:id" element={<Invoice />} />
              {/* Inzamam Routes */}
              <Route path="/calenderview" element={<MyCalender />} />
              <Route
                path="/ChatbotAdminPanel"
                element={
                  <ProtectedRoute
                    allowedRoles={["Admin"]}
                    component={<ChatbotAdminPanel />}
                  />
                }
              />
              <Route path="/locationinfo" element={<LocationInfo />} />
              {/* <Route path='mycalender' element={<MyCalender/>}/>
      <Route path='myfees' element={<MyFees/>}/> */}
              <Route
                path="/myrewards"
                element={
                  <ProtectedRoute
                    allowedRoles={["Student"]}
                    component={<MyRewards />}
                  />
                }
              />
              <Route
                path="/StudentReward"
                element={
                  <ProtectedRoute
                    allowedRoles={["Student"]}
                    component={<StudentReward />}
                  />
                }
              />
              {/* <Route path="/StudentReward" element={<StudentReward />} /> */}
              <Route path="/blogs" element={<Blogs />} />{" "}
              <Route path="/blog/topskilldevelopment" element={<Blog1 />} />{" "}
              <Route path="/blog/onlineSummercampsareimportant" element={<Blog2 />} />{" "}
              <Route path="/blog/howtomanageyourtimewhileonlinelearning" element={<Blog3 />} />{" "}
              {/* Make sure this route is defined */}
              <Route path="/sign-in" element={<SignIn />} />
              <Route path="/signup" element={<SignUp />} />
              <Route path="life-skill-courses" element={<LifeSkillCourses />} />
              <Route path="summer-camp" element={<SummerCamp />} />
              <Route path="winter-camp" element={<WinterCamp />} />
              <Route path="/" element={<PopularCourses />} />{" "}
              {/* Default route to PopularCourses */}
              <Route path="/abacus_home" element={<MathPage />} />
              <Route path="/coding_home" element={<CodingPage />} />
              <Route path="/graphic_designing_portal" element={<GraphicDesignPortal />} />
              <Route path="/quran_portal" element={<QuranPage />} />
              <Route path="/business_portal" element={<BusinessPortal />} />
              <Route path="/engineering_portal" element={<EngineeringPage />} />
              <Route path="/arch_interior_design" element={<ArchitecturePage />} />
              <Route path="/comm_skills_portal" element={<CommunicationPage />} />
              <Route path="/space_sc_portal" element={<SpaceSciencesPage />} />
              <Route path="/graphic_designing_adobexd" element={<AdobeXD />} />
              <Route path="/graphic_designing_corel" element={<CorelDraw />} />
              <Route path="/graphic_designing_photosh" element={<PhotoShop />} />
              <Route path="/graphic_designing_canva" element={<Canva />} />
              <Route path="/graphic_designing_illustr" element={<Illustrator />} />
              <Route path="/graphic_designing_3DModel" element={<ThreeDModel />} />
              <Route path="/graphic_designing_figma" element={<Figma />} />
              <Route path="/business_kidpreneur" element={<Kidprenur />} />
              <Route path="/coding_scratch" element={<ScratchProgramming />} />
              <Route path="/coding_app_development" element={<AppDevelopment />} />
              <Route path="/coding_web_development" element={<WebDevelopment />} />
              <Route path="/coding_game_development" element={<GameDevelopment />} />
              <Route path="/coding_php" element={<PHP />} />
              <Route path="/coding_ai_datascience" element={<AIDataScience />} />
              <Route path="/coding_python" element={<Python />} />
              <Route
                path="/brain-train-abacus"
                element={<BrainTrainAbacusPortal />}
              />
              <Route
                path="/brain-train-abacus-junior"
                element={<BrainTrainAbacusJuniorPortal />}
              />
              <Route
                path="/engineering_civil"
                element={<CivilEngineeringPortal />}
              />
              <Route
                path="/comm_comm_skills"
                element={<CommunicationSkillsCoursePortal />}
              />
              <Route path="/space_sc_atronomy" element={<AstronomyPortal />} />
              <Route
                path="/quran_islamic_knowledge"
                element={<IslamicKnowledgePortal />}
              />
              <Route
                path="/architectureInteriorDesign"
                element={<ArchitectureInteriorDesignPortal />}
              />
              <Route path="/coding_cplus" element={<CppProgrammingPortal />} />
              <Route path="/coding_game_dev_unity" element={<UnityGameDevPortal />} />
              <Route path="/coding_app_dev_androidstu" element={<AndroidAppDevPortal />} />
              <Route
                path="/coding_machine_learning"
                element={<MachineLearningPortal />}
              />
              <Route
                path="/coding_ai_promptengineer"
                element={<AIpromptEngineering />}
              />
              <Route path="//Polymatch/Global_Mental_Math_Competition" element={<MentalMath />} />
              <Route path="/Polymatch/Global_English_Linguistic_Competition" element={<English />} />
              <Route path="Polymatch/Global_IQ_Competition" element={<IQ_competition />} />
              <Route path="/Polymatch/Global_Islamic_Knowledge_Competition" element={<Islamic />} />
              <Route path="/Polymatch/Global_Coding_Competition" element={<Coding />} />
              <Route path="/Polymatch/Global_Graphic_designing_Competition" element={<GraphicDesigning />} />
              <Route path="/Polymatch/Global_Science_Knowledge_Competition" element={<Science />} />
              <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            </Routes>
          </Layout>
        </UserContextProvider>
      </Router>
    </>
  );
}
export default App;
